import React from 'react';
import { ModalAlignEnum } from '@app/common';
import { useTheme } from 'styled-components';
import { cn } from '../../../../utils/tailwind';

type ModalWindowType = {
    children: Array<React.ReactNode> | React.ReactNode;
    locked: boolean;
    width?: number;
    align: ModalAlignEnum;
};

export const ModalWindow: React.FC<ModalWindowType> = ({ children, locked, width, align }: ModalWindowType) => {
    const theme = useTheme();

    return (
        <div
            className={cn(
                'relative z-[1200] inline-flex max-h-full w-full overflow-hidden rounded-medium',
                (locked || align === ModalAlignEnum.Center) && 'text-center',
            )}
            style={{
                maxWidth: width ? `${width}rem` : '56rem',
                backgroundColor: theme.palette.background.body,
            }}
        >
            <div className="flex flex-1 flex-col overflow-x-hidden overflow-y-auto">{children}</div>
        </div>
    );
};
